import { useSyncExternalStore } from "react"

import type { ShellLayout } from "./layout"
import { REFERENCE_WIDTH, resolveLayout } from "./layout"

function subscribe(listener: () => void): () => void {
  window.addEventListener("resize", listener)
  // Поворот телефона меняет ширину не всегда через resize: на части устройств
  // событие приходит только orientationchange, и без него мастер, повернувший
  // телефон в зале, остаётся в раскладке от прошлой ориентации.
  window.addEventListener("orientationchange", listener)
  return () => {
    window.removeEventListener("resize", listener)
    window.removeEventListener("orientationchange", listener)
  }
}

/**
 * Текущая раскладка.
 *
 * Снимок отдаёт СТРОКУ, а не ширину в пикселях, и это не мелочь: React сравнивает снимок
 * по значению и перерисовывает оболочку только когда раскладка действительно сменилась.
 * Возвращай эта функция ширину — каждый пиксель перетаскивания окна перерисовывал бы
 * навигацию, шапку и весь журнал под ними.
 */
export function useShellLayout(): ShellLayout {
  return useSyncExternalStore(subscribe, getLayout, getReferenceLayout)
}

function getLayout(): ShellLayout {
  return resolveLayout(window.innerWidth)
}

function getReferenceLayout(): ShellLayout {
  return resolveLayout(REFERENCE_WIDTH)
}
